import { useCallback, useMemo } from 'react'
import { type Option } from '../types'

export const DENOMINATIONS_NAME = 'denominations'
export const DESIGNS_NAME = 'designs'

interface UseGiftCardOptions {
  isGiftCard: boolean
  options: Option[]
  enabled: boolean
}

export const useGiftCard = ({
  isGiftCard,
  options,
  enabled: enabledProp,
}: UseGiftCardOptions) => {
  const enabled = Boolean(isGiftCard && enabledProp)

  const findByName = useCallback(
    (name: string) =>
      options.find((option) => option.name.toLowerCase() === name),
    [options],
  )

  const denominations = useMemo(
    () => (enabled ? findByName(DENOMINATIONS_NAME) : undefined),
    [enabled, findByName],
  )

  const designs = useMemo(
    () => (enabled ? findByName(DESIGNS_NAME) : undefined),
    [enabled, findByName],
  )

  return {
    enabled,
    denominations,
    designs,
  }
}
